'use client'
import { usePathname } from "next/navigation"
import { useModalStore } from "stores/modalStore"
import { cn } from "utils/cn"

export function AddonSelectPanel({className}: {className?: string}) {
    const pathname = usePathname()
    const isEssential = pathname.includes('essential')
    const { openModal } = useModalStore()
    if(!isEssential) return null
    const isUpgraded = pathname.includes('upgraded')
    return (
        <button onClick={()=> openModal('upgradeHub')} className={cn("px-6 flex items-center flex-nowrap phone-button bg-fp-green w-fit hover:bg-white hover:border-fp-green hover:border-2 border-2 border-fp-green min-w-24 min-h-10 rounded-md text-white hover:text-fp-green", className)}>
            {isUpgraded ? 'Downgrade Panel' : 'Upgrade Panel'}
        </button>
    )
}
